import { Kpi } from '@/components/atoms/kpi';
import type { Municipality } from '@/graphql/types/municipality';
import { useTranslation } from '@/hooks/useTranslation';
import { StyledKpisContainer } from './styles';
import { useState } from 'react';
import { Mobile } from '@/components/molecules/viewport/mobile';
import type { Variable } from '@/graphql/types/variables';
import { kpisData } from './utils';
import { VariableInfoModal } from '@/components/molecules/variable/modal';

interface MunicipalityKpisProps {
  municipality?: Municipality;
  variables: Variable[];
}

export const MunicipalityKpis = ({ municipality, variables }: MunicipalityKpisProps) => {
  const { t } = useTranslation();

  const [openTooltipIndex, setOpenTooltipIndex] = useState<number | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any>(null);

  const kpis = kpisData({ variables, municipality, t });

  const handleTooltipToggle = (index: number) => {
    setOpenTooltipIndex(openTooltipIndex === index ? null : index);
  };

  const handleTooltipClose = () => {
    setOpenTooltipIndex(null);
  };

  return (
    <>
      <StyledKpisContainer>
        {kpis.map((kpi) => (
          <Kpi
            key={kpi.title}
            title={kpi.title}
            value={kpi.value}
            tooltip={kpi.tooltip}
            openTooltipIndex={openTooltipIndex}
            onTooltipToggle={handleTooltipToggle}
            onTooltipClose={handleTooltipClose}
            onOpenModal={() => {
              setOpenModal(true);
              setModalData(kpi.tooltip);
            }}
          />
        ))}
      </StyledKpisContainer>

      <Mobile>
        {openModal && (
          <VariableInfoModal
            title={modalData?.title ?? ''}
            description={modalData?.description ?? ''}
            source={modalData?.source ?? ''}
            period={modalData?.period ?? ''}
            open={openModal}
            onClose={() => setOpenModal(false)}
          />
        )}
      </Mobile>
    </>
  );
};
